import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import React from "react";
import { useSettings } from "../context/SettingsContext";
import { StyledDatePicker } from "./StyledComponents";
import { useTranslation } from "react-i18next";
import { enUS, vi } from "date-fns/locale";

const CustomDatePicker = ({
  name,
  className,
  disabled,
  value,
  onChange,
  readOnly,
  disabledOpenPicker,
  style,
  minDate,
  dateFormat,
  maxDate,
  textFieldSx,
  pickerButtonSx,
  views,
  openTo,
  closeOnSelect = false,
}) => {
  const { settings } = useSettings();
  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  const VN_DOW = ["CN", "T2", "T3", "T4", "T5", "T6", "T7"];
  const EN_DOW = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];

  const dayOfWeekFormatter = (day) => {
    const idx = typeof day?.getDay === "function" ? day.getDay() : day.day?.();
    if (currentLang === "vi") return VN_DOW[idx ?? 0];
    return EN_DOW[idx ?? 0];
  };

  return (
    <StyledDatePicker
      name={name}
      sx={{
        ...(style || {}),

        // wrapper chính
        "& .MuiInputBase-root": {
          height: 40,
          minHeight: 40,
        },

        // input bên trong
        "& .MuiInputBase-input": {
          height: 40,
          padding: "0 14px", // giữ spacing đẹp
          boxSizing: "border-box",
        },

        // icon button (calendar)
        "& .MuiIconButton-root": {
          height: 40,
        },

        // outlined border (tránh bị lệch)
        "& .MuiOutlinedInput-root": {
          height: 40,
        },
      }}
      className={className}
      disabled={disabled}
      format={dateFormat || settings.dateFormat}
      value={value}
      onChange={onChange}
      closeOnSelect={closeOnSelect}
      views={views}
      openTo={openTo}
      minDate={minDate}
      maxDate={maxDate}
      locale={currentLang === "vi" ? vi : enUS}
      dayOfWeekFormatter={dayOfWeekFormatter}
      slots={{
        openPickerIcon: CalendarMonthIcon,
      }}
      slotProps={{
        textField: {
          size: "small",
          focused: false,
          inputProps: {
            readOnly: readOnly, // ✅ chặn typing thật sự
          },
          onBlur: (e) => {
            const val = e.target.value;
            // nếu không parse được → revert
            if (!value || isNaN(new Date(value))) {
              onChange?.(null);
            }
          },
          sx: {
            ...textFieldSx,
          },
        },
      }}
    />
  );
};

export default CustomDatePicker;
